import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = {
    key: 0,
    "data-bs-toggle": "modal",
    "data-bs-target": "#duplicateIngredientModal",
    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-flex align-items-center justify-content-center me-10 mb-10 mb-lg-0 text-nowrap",
    type: "button"
};
const _hoisted_5 = {
    key: 1,
    class: "me-3"
};
const _hoisted_6 = { class: "form-label text-muted small mb-1" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_10 = { class: "table-responsive" };
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_13 = { class: "d-flex align-items-center" };
const _hoisted_14 = { class: "form-check mb-0 me-2" };
const _hoisted_15 = ["checked"];
const _hoisted_16 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_17 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_18 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_19 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_20 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_21 = { key: 0 };
const _hoisted_22 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_24 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_25 = { class: "form-check mb-0 text-capitalize" };
const _hoisted_26 = ["value"];
const _hoisted_27 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_31 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_32 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_33 = ["src"];
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_35 = { class: "form-check form-switch" };
const _hoisted_36 = ["checked", "onChange"];
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_38 = { class: "dropdown" };
const _hoisted_39 = { class: "dropdown-menu" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { key: 2 };
const _hoisted_45 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_46 = { class: "mb-0 text-paragraph" };
const _hoisted_47 = { class: "mt-15 mt-md-0" };
const _hoisted_48 = { class: "pagination mb-0" };
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
    class: "modal fade",
    id: "contentModalScrollable_ingredientTypes",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_51 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_52 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_53 = { class: "modal-header" };
const _hoisted_54 = { class: "modal-title fs-5" };
const _hoisted_55 = { class: "modal-body" };
const _hoisted_56 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_57 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_58 = { class: "text-muted" };
const _hoisted_59 = { key: 2 };
const _hoisted_60 = { class: "table-responsive" };
const _hoisted_61 = { class: "table align-middle mb-0" };
const _hoisted_62 = { class: "bg-success text-white" };
const _hoisted_63 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_64 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_65 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0 text-end" };
const _hoisted_66 = { class: "fw-semibold text-black" };
const _hoisted_67 = ["onUpdate:modelValue"];
const _hoisted_68 = { class: "text-end" };
const _hoisted_69 = ["onClick", "disabled"];
const _hoisted_70 = { class: "modal-footer" };
const _hoisted_71 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_72 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_73 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_74 = { class: "modal-content" };
const _hoisted_75 = { class: "modal-header" };
const _hoisted_76 = {
    class: "modal-title",
    id: "confirmModalLabel"
};
const _hoisted_77 = { class: "modal-body text-center" };
const _hoisted_78 = ["innerHTML"];
const _hoisted_79 = { class: "modal-footer" };
const _hoisted_80 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_81 = {
    class: "modal fade",
    id: "duplicateIngredientModal",
    tabindex: "-1",
    "aria-labelledby": "duplicateIngredientModalLabel",
    "aria-hidden": "true"
};
const _hoisted_82 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_83 = { class: "modal-content" };
const _hoisted_84 = { class: "modal-header bg-white border-bottom-0" };
const _hoisted_85 = {
    class: "modal-title",
    id: "duplicateIngredientModalLabel"
};
const _hoisted_86 = { class: "modal-body text-center" };
const _hoisted_87 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_88 = { key: 1 };
const _hoisted_89 = {
    key: 2,
    class: "mt-3"
};
const _hoisted_90 = { class: "progress" };
const _hoisted_91 = ["aria-valuenow"];
const _hoisted_92 = {
    key: 3,
    class: "text-start mt-3"
};
const _hoisted_93 = {
    key: 0,
    class: "alert alert-success"
};
const _hoisted_94 = {
    key: 1,
    class: "alert alert-warning"
};
const _hoisted_95 = {
    key: 0,
    class: "mt-2 mb-0"
};
const _hoisted_96 = {
    key: 0,
    class: "modal-footer"
};
const _hoisted_97 = ["disabled"];
const _hoisted_98 = {
    key: 1,
    class: "modal-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-flex align-items-center justify-content-center me-10 mb-10 mb-lg-0 text-nowrap",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('ingredient.addIngredient')) + " ", 1),
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ]),
                    (_ctx.selectedItems.length > 0)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
                            _createTextVNode(" Dupliquer (" + _toDisplayString(_ctx.selectedItems.length) + ") ", 1),
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-copy position-relative ms-5 fs-12" }, null, -1))
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('lists.restaurant')), 1),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.selectedRestaurant,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                options: _ctx.restaurantOptions,
                                label: "name",
                                reduce: (restaurant) => restaurant.id,
                                placeholder: _ctx.$t('lists.selectRestaurant'),
                                class: "restaurant-select",
                                onInput: _ctx.onRestaurantChange
                            }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('forms.searchIngredientPlaceholder'),
                            onInput: _cache[3] || (_cache[3] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_8), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("input", {
                                                class: "form-check-input shadow-none",
                                                type: "checkbox",
                                                checked: _ctx.isAllSelected,
                                                onChange: _cache[5] || (_cache[5] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                                            }, null, 40, _hoisted_15)
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.id')), 1)
                                    ])
                                ]),
                                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('lists.name')), 1),
                                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('lists.icon')), 1),
                                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('lists.type')), 1),
                                _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('lists.availability')), 1),
                                _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('lists.extraPrice')), 1),
                                _cache[16] || (_cache[16] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                    _createElementVNode("td", _hoisted_22, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allIngredient.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allIngredient, (ingredient, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: ingredient.id
                                        }, [
                                            _createElementVNode("th", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.selectedItems) = $event)),
                                                            value: ingredient.id
                                                        }, null, 8, _hoisted_26), [
                                                            [_vModelCheckbox, _ctx.selectedItems]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_27, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(ingredient))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(ingredient.id)), 9, _hoisted_28)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_29, _toDisplayString(ingredient.name), 1),
                                            _createElementVNode("th", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("div", _hoisted_32, [
                                                        _createElementVNode("img", {
                                                            src: _ctx.getIngredientImage(ingredient),
                                                            class: "rounded-circle me-8",
                                                            width: "24",
                                                            height: "24",
                                                            alt: "ingredient"
                                                        }, null, 8, _hoisted_33)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(ingredient.ingredientTypeLabel ?? '-'), 1),
                                            _createElementVNode("td", _hoisted_34, [
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        checked: _ctx.getIngredientAvailability(ingredient),
                                                        onChange: ($event) => (_ctx.toggleIngredientActivation(ingredient, $event))
                                                    }, null, 40, _hoisted_36)
                                                ])
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.formatExtraCostPrice(ingredient)), 1),
                                            _createElementVNode("td", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                    _cache[21] || (_cache[21] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_39, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(ingredient))
                                                            }, [
                                                                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.view')), 1)
                                                            ], 8, _hoisted_40)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(ingredient))
                                                            }, [
                                                                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1)
                                                            ], 8, _hoisted_41)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.duplicateIngredientAction(ingredient))
                                                            }, [
                                                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "flaticon-copy lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.duplicate')), 1)
                                                            ], 8, _hoisted_42)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDelete(ingredient))
                                                            }, [
                                                                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                                                            ], 8, _hoisted_43)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                        _createVNode(_component_EmptyTable, {
                                            message: _ctx.$t('ingredient.noIngredients'),
                                            colspan: 8,
                                            textClass: "text-muted"
                                        }, null, 8, ["message"])
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_47, [
                        _createElementVNode("ul", _hoisted_48, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_49)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[23] || (_cache[23] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("h1", _hoisted_54, _toDisplayString(_ctx.$t('ingredient.manageTypePositions')), 1),
                        _cache[24] || (_cache[24] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                        (_ctx.isLoadingTypes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createVNode(_component_LoaderComponent)
                            ]))
                            : (_ctx.ingredientTypes.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('ingredient.noTypesAvailable')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("table", _hoisted_61, [
                                            _createElementVNode("thead", _hoisted_62, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.$t('ingredient.type')), 1),
                                                    _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.$t('ingredient.position')), 1),
                                                    _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.$t('common.actions')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedIngredientTypes, (type) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: type.type
                                                    }, [
                                                        _createElementVNode("td", _hoisted_66, _toDisplayString(type.type), 1),
                                                        _createElementVNode("td", null, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                class: "form-control shadow-none rounded-0 text-black",
                                                                "onUpdate:modelValue": ($event) => ((type.position) = $event),
                                                                min: "1",
                                                                style: { "width": "100px" }
                                                            }, null, 8, _hoisted_67), [
                                                                [
                                                                    _vModelText,
                                                                    type.position,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_68, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => (_ctx.updateTypePosition(type)),
                                                                class: "btn btn-sm btn-primary",
                                                                type: "button",
                                                                disabled: _ctx.isUpdatingPosition
                                                            }, [
                                                                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                                            ], 8, _hoisted_69)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("button", _hoisted_71, _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("h5", _hoisted_76, _toDisplayString(_ctx.$t('ingredient.deleteConfirmation')), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", {
                            class: "mb-0",
                            innerHTML: _ctx.$t('ingredient.deleteConfirmationText')
                        }, null, 8, _hoisted_78)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("button", _hoisted_80, [
                            _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.confirmationDeleteAction(_ctx.ingredientSelected))),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("h5", _hoisted_85, _toDisplayString(_ctx.duplicationResult ? 'Résultat de la duplication' : `Dupliquer ${_ctx.selectedItems.length} ingrédients`), 1),
                        _cache[30] || (_cache[30] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                        (!_ctx.duplicationResult)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_87, " Sélectionnez le restaurant cible : "))
                            : _createCommentVNode("", true),
                        (!_ctx.isDuplicating && !_ctx.duplicationResult)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.duplicationTargetRestaurants,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.duplicationTargetRestaurants) = $event)),
                                    options: _ctx.restaurantOptions.filter(r => r.id !== _ctx.selectedRestaurant),
                                    label: "name",
                                    multiple: "",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: "Sélectionnez un ou plusieurs restaurants",
                                    class: "restaurant-select text-start"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ]))
                            : (_ctx.isDuplicating)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                    _createElementVNode("p", null, "Duplication en cours... " + _toDisplayString(_ctx.duplicationProgress) + "%", 1),
                                    _createElementVNode("div", _hoisted_90, [
                                        _createElementVNode("div", {
                                            class: "progress-bar progress-bar-striped progress-bar-animated bg-success",
                                            role: "progressbar",
                                            style: _normalizeStyle('width: ' + _ctx.duplicationProgress + '%'),
                                            "aria-valuenow": _ctx.duplicationProgress,
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                        }, null, 12, _hoisted_91)
                                    ])
                                ]))
                                : (_ctx.duplicationResult)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        (_ctx.duplicationResult.success > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-check-circle me-2" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.duplicationResult.success) + " élément(s) dupliqué(s) avec succès. ", 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.duplicationResult.failed > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.duplicationResult.failed) + " élément(s) ignoré(s) ou en échec : ", 1),
                                                (_ctx.duplicationResult.errors && _ctx.duplicationResult.errors.length > 0)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_95, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicationResult.errors, (err, i) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(err), 1));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                    ]),
                    (!_ctx.isDuplicating && !_ctx.duplicationResult)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                            _cache[34] || (_cache[34] = _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                "data-bs-dismiss": "modal",
                                id: "closeDuplicateIngredientModal"
                            }, [
                                _createElementVNode("i", { class: "fas fa-times me-2" }),
                                _createTextVNode("Annuler ")
                            ], -1)),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[11] || (_cache[11] =
                                    //@ts-ignore
                                    (...args) => (_ctx.triggerDuplication && _ctx.triggerDuplication(...args))),
                                disabled: _ctx.duplicationTargetRestaurants.length === 0
                            }, [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("i", { class: "fas fa-copy me-2" }, null, -1),
                                    _createTextVNode("Dupliquer ", -1)
                                ]))], 8, _hoisted_97)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.duplicationResult)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                "data-bs-dismiss": "modal",
                                onClick: _cache[12] || (_cache[12] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetDuplicationState && _ctx.resetDuplicationState(...args)))
                            }, [...(_cache[35] || (_cache[35] = [
                                    _createElementVNode("i", { class: "fas fa-check me-2" }, null, -1),
                                    _createTextVNode("Fermer ", -1)
                                ]))])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ], 64));
}
